export default __webpack_public_path__ + "images/0x29b0da86e484e1c0029b56e817912d778ac0ec69.png";